<script setup>
import { useI18n } from 'vue-i18n'
import { onMounted, ref } from 'vue'

const { t } = useI18n()
const isClient = ref(false)

onMounted(() => {
  isClient.value = true
})

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>

<template>
  <footer class="footer">
    <div class="footer-grid">
      
      <!-- LOCATION -->
      <div>
        <h3 class="footer-title">{{ t('footer.locationTitle') }}</h3>
        <h5>{{ t('footer.locationName') }}</h5>
        <p class="info" v-html="t('footer.address')"></p>
      </div>

      <!-- INFO & RESERVATIONS -->
      <div>
        <h3 class="footer-title">{{ t('footer.infoTitle') }}</h3>
        <p class="p-info">
          {{ t('footer.phone') }}<br> {{ t('footer.phone2') }} <br>
          <a :href="`mailto:${t('footer.email')}`" class="footer-link">{{ t('footer.email') }}</a>
        </p>
      </div>

      <!-- CURRENTLY CLOSED -->
      <div>
        <h3 class="footer-title">{{ t('footer.closedTitle') }}</h3>
        <p class="p-info">{{ t('footer.closedText') }}</p>
      </div>

      <!-- FOLLOW US -->
      <div>
        <h3 class="footer-title">{{ t('footer.followTitle') }}</h3>
        <p class="p-info">
         
          <a href="https://www.instagram.com/alwayshungryfoods/" class="footer-link">{{ t('footer.instagram') }}</a>
        </p>
      </div>

    </div>

    

   <button @click="scrollToTop" class="scroll-top" :aria-label="t('footer.scrollTop')">
      <svg xmlns="http://www.w3.org/2000/svg" class="arrow-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
      </svg>
    </button> 
     <div class="footer-bottom">
      {{ t('footer.copyright') }} 
      <a href="https://katerinamaksimov.com/" class="footer-link">Katerina Maksimov</a>
    </div>
  </footer>
</template>


<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
</style>
<style scoped>
 body{
  font-family: 'Montserrat', sans-serif;
font-family: 'Cormorant Garamond', sans-serif;
 }
.footer {
  background-color: #39383D;
  color: #f5f5f5;
  padding: 1rem 3rem;
  position: relative;
  bottom: 0;
  left: 0;
  z-index: 10;
  font-family: 'Montserrat', sans-serif;
  justify-content: flex-end;
  width: 100% ;
  
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
  font-size: 0.95rem;
  line-height: 1.6;
  width: 100%   ;
}

.footer-title {
  text-transform: uppercase;
  font-weight: 500;
  color: #e2e2e2;
  margin-bottom: 0.8rem;
  font-size: 0.9rem;
  font-weight: 500;
   font-family: 'Montserrat', sans-serif;
}
h3.footer-title{
font-size: 1.5rem;
  font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 0.9rem;
text-align: left;




}
.footer-link {
  color: #dcdcdc;
  opacity: 0.8;
  transition: color 0.3s ease;
  text-decoration: none;
}

.footer-link:hover {
  color: #ffffff;
}

.footer-bottom {
  text-align: center;
  font-size: 0.8rem;
  color: #c2c2c2;
  margin-top: 3rem;
}

.scroll-top {
  position: absolute;
  right: 1rem;
  bottom: 2rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #e8e8e8;
  transition: transform 0.3s ease, color 0.3s ease;
}

.scroll-top:hover {
  transform: translateY(-5px);
  color: #ffffff;
}

.arrow-icon {
  width: 2.5rem;
  height: 2.5rem;
}
p{
font-family: 'Cormorant Garamond', sans-serif;

  font-size: 17px;
}

h5{
font-family: 'Cormorant Garamond', sans-serif;
  font-size: 17px;
margin: 0;
font-style:normal;
padding: 0;
}
/* RESPONSIVENESS */
@media (max-width: 850px) {
  .footer {
    padding: 0.5rem 1rem;
  }

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.5rem;
  font-size:clamp(2rem, 2.5vw, 3.5rem);
  line-height: 1.6;
}
.arrow-icon {
  width: 4rem;
  height: 9rem;
}
p{
  
  font-size: 15px;
}
}
@media (max-width:   550px) {
  .footer {
    padding: 0.5rem 1rem;
  }

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.5rem;
  font-size:clamp(2rem, 2.5vw, 3.5rem);
  line-height: 1.6;
}
.arrow-icon {
  width:   3rem;
  height: 9rem;
}
p{
  
  font-size: 15px;
}
}
</style>